import { Service } from '../../interfaces/service.interface';
import { InfoService } from '../../interfaces/infoservice.interface';
import { Company } from '../../interfaces/company.interface';
import { ParamsService } from '../../services/params.service';
import { DataService } from '../../services/data.service';
import { NavigationEnd } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
	
	@Input() idrub:string;
	@Output() onNavigate:EventEmitter<string> = new EventEmitter();
	
	mobile:boolean;
	

  constructor(
		public dataService:DataService,
		private paramsService:ParamsService,
		private breakpointObserver: BreakpointObserver,
	) {
		
		// this.mobile = this.breakpointObserver.isMatched('(max-width: 768px)');
		this.breakpointObserver.observe('(max-width: 768px)')
		.subscribe((resp) => this.mobile = resp.matches);
		
		this.paramsService.addListener('localize', this.onLocalize.bind(this));
		this.paramsService.addListener('openModal', this.onOpenModal.bind(this));
	}
	
	
	

  ngOnInit() {
		
		
	}
	
	
	onLocalize(item:Company & InfoService & Service):void
	{
		// debugger;
		if(this.mobile){
			//close currently open rub
			this.onclick(item.rubric);
		}
	}
	onOpenModal():void
	{
		if(this.mobile){
			this.idrub = '';
			this.onclick('');
		}
	}
	
	onclick(idrub:string):void
	{
		this.onNavigate.emit(idrub);
	}
	
	
}
